import { render, staticRenderFns } from "./StackedPlotItem.vue?vue&type=template&id=44d6c6d2&"
import script from "./StackedPlotItem.vue?vue&type=script&lang=js&"
export * from "./StackedPlotItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports